import {PRODUCTION} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

export function getClarityID(): string {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "rjcus34cl2" // clarity prod key
  }
  return "rurmw2ricz" // clarity staging key
}
